import { GatewayControleQuinquennal } from "@conformite/gateway";
import { getDownloadedFile, downloadFile } from "@src/helper/file.helper";
import { userSession } from "@src/data/session/UserSession";

type ZipSignedUrlResponse =
  | { url: string; checksum: string; key: string }
  | { error: string };

export class FilesApi {
  static async addFileToAxe(
    controleQuinquennalId: string,
    axeId: string,
    file: File,
    typePieceDeclare?: string
  ): Promise<GatewayControleQuinquennal.ControleQuinquennalAxeFile> {
    const formData = new FormData();
    formData.append("document", file);
    if (typePieceDeclare) {
      formData.append("typePieceDeclare", typePieceDeclare);
    }

    const { data } =
      await userSession.axiosInstance.post<GatewayControleQuinquennal.ControleQuinquennalAxeFile>(
        `/admin/controle-quinquennal/${controleQuinquennalId}/axes/${axeId}/files`,
        formData
      );

    return data;
  }

  static async downloadSingleFile(
    siren: string,
    millesime: number,
    pathname: string,
    filename: string,
    isAdmin = false
  ): Promise<void> {
    const downloadedFile = await getDownloadedFile(
      siren,
      millesime,
      pathname,
      filename,
      isAdmin
    );
    if (downloadedFile) {
      downloadFile(downloadedFile.file, downloadedFile.filename);
    }
  }

  static async triggerZipExport(
    controleQuinquennalId: string,
    axeId: string,
    email?: string
  ): Promise<void> {
    const params = email ? `?email=${encodeURIComponent(email)}` : "";
    await userSession.axiosInstance.post(
      `/admin/controle-quinquennal/${controleQuinquennalId}/axes/${axeId}/files/zip${params}`
    );
  }

  static async getZipSignedUrl(
    controleQuinquennalId: string,
    axeId: string
  ): Promise<string | null> {
    const { data } = await userSession.axiosInstance.get<ZipSignedUrlResponse>(
      `/admin/controle-quinquennal/${controleQuinquennalId}/axes/${axeId}/files/zip/url`
    );
    if ("url" in data) {
      return data.url;
    }
    return null;
  }

  static async triggerDossierZipExport(
    controleQuinquennalId: string,
    email?: string
  ): Promise<void> {
    const params = email ? `?email=${encodeURIComponent(email)}` : "";
    await userSession.axiosInstance.post(
      `/admin/controle-quinquennal/${controleQuinquennalId}/files/zip${params}`
    );
  }

  static async getDossierZipSignedUrl(
    controleQuinquennalId: string
  ): Promise<string | null> {
    const { data } = await userSession.axiosInstance.get<ZipSignedUrlResponse>(
      `/admin/controle-quinquennal/${controleQuinquennalId}/files/zip/url`
    );
    if ("url" in data) {
      return data.url;
    }
    return null;
  }

  static async getZipMetadata(
    controleQuinquennalId: string,
    axeId: string
  ): Promise<{
    generatedAt: string | null;
    isUpToDate: boolean;
  }> {
    const { data } = await userSession.axiosInstance.get<{
      generatedAt: string | null;
      isUpToDate: boolean;
    }>(
      `/admin/controle-quinquennal/${controleQuinquennalId}/axes/${axeId}/files/zip/metadata`
    );
    return data;
  }
}
